<template>
  <div class="row">
    <div class="col-lg-4 col-md-5">
      <user-card></user-card>
    </div>

    <div class="col-lg-8 col-md-7">
      <edit-profile-form @on-submit="onUpdateModelSubmit"></edit-profile-form>
    </div>
  </div>
</template>
<script>
  import EditProfileForm from './UserProfile/EditProfileForm.vue'
  import UserCard from './UserProfile/UserCard.vue'

  export default {
    components: {
      EditProfileForm,
      UserCard
    },
    

    data () {
      return {
        
      }
    },
    methods : {
      onUpdateModelSubmit (model, isValid) {
        
        this.$http.put('/profiles', {
          firstName: model.firstName,
          lastName: model.lastName,
          phone: model.phone,
          address: model.address,
          city: model.city,
          state_id: model.state_id,
          country:  model.country,
          postal_code: model.postal_code,
        })
        .then(response=>{

          console.log(response.data)
        })
        .catch(error=>{console.error(error)})
      }
    }
  }

</script>
<style>

</style>
